// src\components\Payroll\ProcessPartialSalaryFld\shared\RevertBatchForm.jsx
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { WorkflowStatus } from "../../../../utils/enums";

/**
 * RevertBatchForm
 *
 * Props:
 *   isOpen    — boolean
 *   onClose   — () => void
 *   batches   — array of batch objects
 *   onRevert  — (batchId, onClose) => void
 *
 * Only shows batches with status === WorkflowStatus.STAGING
 */
export const RevertBatchForm = ({ isOpen, onClose, batches, onRevert }) => {
  const [batchId, setBatchId] = useState("");
  const [errorState, setErrorState] = useState(false);

  useEffect(() => {
    if (!isOpen) { setBatchId(""); setErrorState(false); }
  }, [isOpen]);

  const submit = () => {
    if (!batchId) { setErrorState(true); return; }
    onRevert(batchId, onClose);
    setErrorState(false);
  };

  const stagingBatches = batches.filter((b) => b.status === WorkflowStatus.STAGING);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay open">
      <div className="modal">
        <div className="popUp-header row">
          <div className="popUp-title">
            <h3 style={{ color: "#668fca" }}>Revert Staging</h3>
          </div>
          <div className="popUp-close"><CloseIcon onClick={onClose} /></div>
        </div>

        <div className="popUp-body column" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="popUp-item info-item column">
            <div className="info-item-label">Batch (Staging only)</div>
            <div className="info-item-input">
              <select
                value={batchId}
                onChange={(e) => setBatchId(e.target.value)}
                style={{ color: batchId ? "rgb(104,104,104)" : "rgba(0,0,0,0.356)" }}
              >
                <option value="" disabled hidden>Select a batch</option>
                {stagingBatches.map((b) => (
                  <option key={b.id} value={b.id}>
                    {`Batch #${b.id} — ${b.payrollPeriodIdentifier || b.payrollPeriodName || `Period ${b.payrollPeriodId}`} | ${b.effectiveDate ? b.effectiveDate.split("T")[0] : ""} | ${b.status ?? "—"}`}
                  </option>
                ))}
              </select>
            </div>
            <span style={{ visibility: !batchId && errorState ? "visible" : "hidden", color: "#ff6565", fontSize: "12px" }}>
              Please select a batch
            </span>
          </div>
        </div>

        <div className="buttons row" style={{ justifyContent: "end", padding: "40px 40px 20px 40px" }}>
          <button className="save row" onClick={submit} style={{ marginRight: "5px", backgroundColor: "#ff4d4d" }}>REVERT</button>
          <button className="cancel row" onClick={onClose}>CANCEL</button>
        </div>
      </div>
    </div>
  );
};